import client from './client';
import { Overlay } from '../types';

export const overlaysApi = {
  list: (eventId: string) =>
    client.get<Overlay[]>(`/events/${eventId}/overlays`).then((r) => r.data),

  upload: (eventId: string, name: string, file: File) => {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('file', file);
    return client
      .post<Overlay>(`/events/${eventId}/overlays`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },

  delete: (eventId: string, overlayId: string) =>
    client.delete(`/events/${eventId}/overlays/${overlayId}`).then((r) => r.data),

  fileUrl: (overlayId: string) => `/api/v1/overlays/${overlayId}/file`,
};
